export function removeLineBreaks(string) {
    return string.replaceAll(/\n/g, '');
}
